module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/_library.js
// module id = 36
// module chunks = 0